module.exports = __webpack_public_path__ + "img/arrow_select.d25129ae.svg";